var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentsLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3370",
    "data-name": "Rectangle 3370",
    width: 32,
    height: 32,
    transform: "translate(1055 -304)",
    fill: "#333",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0646\\u0638\\u0631\\u0633\\u0646\\u062C\\u06CC",
    transform: "translate(-1055 304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8923",
    "data-name": "Group 8923",
    transform: "translate(4 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M26.667,26.667H8V8H21.333V5.333H8A2.675,2.675,0,0,0,5.333,8V26.667A2.675,2.675,0,0,0,8,29.333H26.667a2.675,2.675,0,0,0,2.667-2.667V16H26.667Z",
    transform: "translate(1049.667 -310.333)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__2",
    "data-name": "__TEMP__SVG__",
    d: "M13.422,15.511l-1.867,1.867,6,6L30.889,10.044,29.022,8.178l-11.467,11.4Z",
    transform: "translate(1048.111 -311.044)",
    fill: "#333",
    opacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsLog);
export default __webpack_public_path__ + "static/media/comments-log.2ce0920a3ed1af8247e17486875846f6.svg";
export { ForwardRef as ReactComponent };